module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._c;
  return _c('div', {
    staticClass: "page__hd",
    on: {
      "click": _vm.onItemClick
    }
  }, [_c('h1', {
    staticClass: "page__title"
  }, [_vm._v(_vm._s(_vm.title))]), _vm._v(" "), _c('p', {
    staticClass: "page__desc"
  }, [_vm._v(_vm._s(_vm.desc))])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/.10.0.2@vue-loader/lib/template-compiler.js?id=data-v-60f94960!./~/.10.0.2@vue-loader/lib/selector.js?type=template&index=0!./src/components/article/page-head.vue
// module id = 251
// module chunks = 0